import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function initSwiperAlumni() {

  new Swiper('.swiper--alumni', {
    modules: [Navigation],
    spaceBetween: 8,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    watchOverflow: true,
    loop: false,
    centeredSlides: false,
    slidesPerView: 1,
    breakpoints: {
      768: { slidesPerView: 2 },
      1080: { slidesPerView: 2.5 },
      1920: { slidesPerView: 3.5 }
    },
    navigation: {
      nextEl: '.swiper--alumni .swiper-button-next',
      prevEl: '.swiper--alumni .swiper-button-prev'
    }
  });
}

function initSwiperWorkshops() {


  new Swiper('.swiper--workshops', {
    modules: [Navigation],
    spaceBetween: 8,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    watchOverflow: true,
    loop: false,
    centeredSlides: false,
    slidesPerView: 1,
    breakpoints: {
      768: { slidesPerView: 2 },
      1080: { slidesPerView: 2, centeredSlides: true, loop: true }
    },
    navigation: {
      nextEl: '.swiper--workshops .swiper-button-next',
      prevEl: '.swiper--workshops .swiper-button-prev'
    }
  });
}

initSwiperAlumni();
initSwiperWorkshops();

// mqDestroy.addEventListener('change', initSwiperAlumni);
// mqLarge.addEventListener('change', () => {
//   initSwiperWorkshops();
// });
